import React from 'react';
import PropTypes from 'prop-types';
import Link from '../Link';
import {
  customerCareEmail,
  pressEmail,
  businessEmail,
  hrEmail,
  marketingEmail,
  mailTo,
} from '../../helpers/emailAddresses';
import { Wrapper } from '../../components_desktop/css_global/utils.css';
import { LinkWrapper, List, StaticPageHeader } from '../../components_mobile/css_global/utils.css';
import VerticalSpacer from '../VerticalSpacer/VerticalSpacer';
import withCountryCode from '../../components/RoutesHoc/RoutesHoc';
import { angeListJobs, ipForm } from '../../helpers/routes';

const ContactUsContent = ({ isDesktop, buildUrlWithCountry }) => (
  <Wrapper padding="20px" font={'"Avenir Light", "Arial", sans-serif'} lineHeight="1.5" margin="0 0 3px 0">
    <VerticalSpacer height="10px" />
    <StaticPageHeader fontWeight="bold" margin="0">
      Customer care
    </StaticPageHeader>
    <VerticalSpacer height="10px" />
    <Wrapper margin="0 0 10px 0">
      Have questions? Our customer care team is available 24/7 to assist you with:
      <List margin={isDesktop ? '1% 0 0 3%' : '2% 0 0 7%'}>
        <li>Orders and payments</li>
        <li>Shipping and deliveries</li>
        <li>Returns and refunds</li>
      </List>
    </Wrapper>
    <Wrapper margin="0 0 30px 0">
      You can reach a representative instantly through our live chat or send an email to
      <Link href={mailTo(customerCareEmail)}>
        <LinkWrapper inline padding="0 5px">
          {customerCareEmail}
        </LinkWrapper>
      </Link>
      if you have further questions.
    </Wrapper>
    <VerticalSpacer height="10px" />
    <StaticPageHeader fontWeight="bold" margin="0">
      Careers
    </StaticPageHeader>
    <VerticalSpacer height="10px" />
    <Wrapper>
      Although our partner boutiques are in Italy, italist is an American company. We have a growing team of 50+
      employees dedicated to bringing you the widest selection and best value in luxury fashion and accessories.
    </Wrapper>
    <VerticalSpacer height="15px" />
    <Wrapper>
      Interested in joining the team? View open positions at our Los Angeles and Milan offices on
      <Link href={angeListJobs}>
        <LinkWrapper inline padding={isDesktop ? '0 0 0 5px' : '0 0 0 5px'}>
          AngelList
        </LinkWrapper>
      </Link>
      .
    </Wrapper>
    <VerticalSpacer height="15px" />
    <Wrapper margin="0 0 30px 0">
      Don't see what you're looking for? Email
      <Link href={mailTo(hrEmail)}>
        <LinkWrapper inline padding={isDesktop ? '0 0 0 5px' : '0 5px'}>
          {hrEmail}
        </LinkWrapper>
      </Link>
    </Wrapper>
    <VerticalSpacer height="10px" />
    <StaticPageHeader fontWeight="bold" margin="0">
      Other Inquiries
    </StaticPageHeader>
    <VerticalSpacer height="10px" />
    <Wrapper>
      Press queries:
      <Link href={mailTo(pressEmail)}>
        <LinkWrapper inline padding={isDesktop ? '0 0 0 5px' : '0 5px'}>
          {pressEmail}
        </LinkWrapper>
      </Link>
    </Wrapper>
    <VerticalSpacer height="10px" />
    <Wrapper>
      Boutiques and designers:
      <Link href={mailTo(businessEmail)}>
        <LinkWrapper inline padding={isDesktop ? '0 0 0 5px' : '0 5px'}>
          {businessEmail}
        </LinkWrapper>
      </Link>
    </Wrapper>
    <VerticalSpacer height="10px" />
    <Wrapper margin="0 0 30px 0">
      Marketing partnership:
      <Link href={mailTo(marketingEmail)}>
        <LinkWrapper inline padding={isDesktop ? '0 0 0 5px' : '0 5px'}>
          {marketingEmail}
        </LinkWrapper>
      </Link>
    </Wrapper>
    <Wrapper margin="0 0 30px 0">
      <div>Our offices are located in Los Angeles:</div>
      <div>10350 Santa Monica Boulevard, Suite 160</div>
      <div>Los Angeles, CA 90025</div>
      <div>United States of America</div>
    </Wrapper>
    <VerticalSpacer height="10px" />
    <StaticPageHeader fontWeight="bold" margin="0">
      Intellectual Property Feedback
    </StaticPageHeader>
    <VerticalSpacer height="10px" />
    <Wrapper margin={isDesktop ? '0 0 85px 0' : '0 0 50px 0'}>
      To report possible intellectual property infringements, please click{' '}
      <Link href={buildUrlWithCountry(ipForm)}>
        <LinkWrapper padding="0" inline>
          here
        </LinkWrapper>
      </Link>
      .
    </Wrapper>
  </Wrapper>
);

ContactUsContent.propTypes = {
  isDesktop: PropTypes.bool.isRequired,
  buildUrlWithCountry: PropTypes.func.isRequired,
};

export default withCountryCode(ContactUsContent);
